import React from "react"
import Stack from "@mui/material/Stack"
import Box from "@mui/material/Box"
import { getClassNameActive } from "../config"
import MenuWithSubItem from "./menu-with-sub-item"
import WrapperLinkHover from "@src/components/WrapperLinkHover"
import { useTranslation } from "react-i18next"
import NextLink from "@src/components/NextLink"
import { blackFridayTextSx } from "@src/constants"

const Menu = ({ menuConfigList, currentPath, onRedirect }) => {
  const { t } = useTranslation()
  return (
    <Stack
      alignItems="center"
      justifyContent="space-evenly"
      sx={{
        flexGrow: 1,
        height: "100%",
        padding: "0 16px",
        "& .MuiStack-root": {
          display: "flex",
          alignItems: "center",
          lineHeight: "24px",
          justifyContent: "center",
          height: "100%",
          "& a": {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "100%",
            color: "#434343",
            fontSize: 16,
            whiteSpace: "nowrap",
            textDecoration: "none",
            "&:hover": {
              fontWeight: 700,
              color: "#000"
            },
            "&.active": {
              fontWeight: 700,
              color: "#000"
            }
          }
        }
      }}
    >
      {menuConfigList && menuConfigList.map((item, index) => (
        <WrapperLinkHover key={`${item.key}-${index}`} title={t(item.key)}>
          {item?.subMenu ? (
            <MenuWithSubItem
              key={index}
              data={item}
              currentPath={currentPath}
              onRedirect={onRedirect}
            />
          ) : item.key === "on_sale" ? (
            <NextLink
              key={index}
              className={getClassNameActive(item, currentPath)}
              href={item.path}
              sx={{
                "& a": {
                  display: "inline-flex !important",
                  alignItems: "center",
                  justifyContent: "center",
                  height: "100%",
                  textDecoration: "none",
                  "& .bf-text": {
                    ...blackFridayTextSx,
                    transition: "transform 0.25s ease"
                  },
                  "&:hover .bf-text": {
                    transform: "scale(1.06)"
                  }
                }
              }}
            >
              <Box component="span" className="bf-text">
                {t(item.key)}
              </Box>
            </NextLink>
          ) : (
            <NextLink
              key={index}
              className={getClassNameActive(item, currentPath)}
              href={item.path}
              style={{
                color: item.color,
              }}
            >
              {t(item.key)}
            </NextLink>
          )}
        </WrapperLinkHover>
      ))}
    </Stack>
  )
}

export default Menu
